import { orderStore } from "../store/orderStore";
export const recreateOrder = {
    methods: {
        $_recreateOrder(order) {
            this.loadingRebuy = true;
            let extras = order.extras;
            let recipes = order.recipes;
            let extraParams = [];
            let recipesParams = {};
            /* orderStore.state.order = null */
            extras.forEach((extra) => {
                extraParams.push({ id: extra.id, quantity: extra.quantity });
            });
            recipes.forEach((recipe) => {
                if (
                    this.menuStore.menu.recipes.some((el) => recipe.id == el.id)
                ) {
                    recipesParams[recipe.id] = {
                        id: recipe.id,
                        quantity: recipe.quantity,
                    };
                }
            });
            orderStore.updateOrderParam({
                param: "recipes_id",
                value: recipesParams,
            });
            orderStore.updateOrderParam({ param: "extra", value: extraParams });
            return orderStore.updateOrder().finally((i) => {
                this.loadingRebuy = false;
                this.$router.push({ name: "flow-subscribed" });
            });
        },
    },
};
